import { configureStore } from '@reduxjs/toolkit';
import authSlice from './auth/auth-slice';
import chatSlice from './chat/chat-slice';

const store = configureStore({
  reducer: { auth: authSlice.reducer, chat: chatSlice.reducer },
});

export default store;
